import React, { createContext, useContext, useEffect, useState } from "react";
import { USD_TO_AED } from "../data/constants";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("USD");
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [isUAE, setIsUAE] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Contact info based on region
  const contactInfo = isUAE
    ? {
        phone: "+971 43185333",
        email: "Connect@big1062.com",
        address: "HOCKWOOD Digital DMCC",
        addressLine2: "3401, Saba 1, Cluster E - Dubai",
        location: "Dubai, UAE"
      }
    : {
        phone: "+1 (469) 991-1289",
        email: "info@funasiadigital.com",
        address: "FunAsia Digital",
        addressLine2: "",
        location: "Dallas, TX"
      };

  useEffect(() => {
    const detectLocation = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        if (data.country_code === "AE") {
          setCurrency("AED");
          setCurrencySymbol("AED ");
          setIsUAE(true);
        }
      } catch (error) {
        // Geolocation lookup failed; fall back to USD/US silently in UI but log
        // for ops visibility. ipapi.co is free-tier and occasionally rate-limits.
        // eslint-disable-next-line no-console
        console.warn("[CurrencyContext] geolocation lookup failed, using US/USD default:", error?.message || error);
      } finally {
        setIsLoading(false);
      }
    };
    detectLocation();
    // detectLocation is defined inside the effect; the effect intentionally
    // runs once on mount to detect region.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatPrice = (usdPrice) => {
    if (typeof usdPrice === "string" && !usdPrice.match(/^\$?\d/)) return usdPrice;
    const numericValue =
      typeof usdPrice === "string" ? parseFloat(usdPrice.replace(/[^0-9.]/g, "")) : usdPrice;
    if (isNaN(numericValue)) return usdPrice;
    if (currency === "AED") {
      const aedValue = Math.round(numericValue * USD_TO_AED);
      return `AED ${aedValue.toLocaleString()}`;
    }
    return `$${numericValue.toLocaleString()}`;
  };

  return (
    <CurrencyContext.Provider
      value={{ currency, currencySymbol, formatPrice, isLoading, isUAE, contactInfo }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
